import type { HolidayServiceArea, HolidayServiceAreaWrapper } from "../../../typings/HolidayServiceArea";



export const CreateHolidayServiceAreasWrapper = (jsonString: string): HolidayServiceAreaWrapper => {
  try {
    return JSON.parse(jsonString) as HolidayServiceAreaWrapper;
  } catch {}

  return null;
};

export class HolidayScheduleByStateRow {
  holidayName: string;

  holidayDateFormatted: string;

  daysToGo: string;

  pickupLabel: string;

  nextDeliveryTable: Array<Array<string>>;

  customMessage: string;

  customerType: string[];

  numberofDaysDelay: number;

  isMEOrNH: boolean;

  upcoming: boolean;

  constructor(holidayServiceArea: HolidayServiceArea, areaValue?: string) {
    this.holidayName = holidayServiceArea.HolidayName;

    this.holidayDateFormatted = holidayServiceArea.HolidayDateLabel;


    this.pickupLabel =
      holidayServiceArea.States.indexOf(areaValue) !== -1
        ? holidayServiceArea.SelectedStatesServiceLabel
        : holidayServiceArea.OthersStatesServiceLabel;

    this.numberofDaysDelay = holidayServiceArea.NumberofDaysDelay;

    //daysToGo is returning a full string with correct labels from backend, no longer need this method

    //this.calculateDaysToGo(holidayServiceArea.HolidayDateTimeUtc, serverDateTime);

    this.daysToGo = holidayServiceArea.DaysToGo;

    this.nextDeliveryTable = this._getNextDeliveryTable(holidayServiceArea);

    this.customMessage = holidayServiceArea.CustomMessage || "";

    this.customerType = holidayServiceArea.CustomerType;

    this.isMEOrNH = this._hasNHorME(holidayServiceArea.States);
  }

  _getNextDeliveryTable(holidayServiceArea: HolidayServiceArea): Array<Array<string>> {
    const daysString = holidayServiceArea.NextDeliveryTable;

    const daysArray = JSON.parse(daysString);

    const newDaysArray = daysArray.map((item) => {
      const days = item.replace(/[{}]/g, "").split(",");

      return days;
    });

    return newDaysArray;
  }

  _hasNHorME(states) {
    return states.includes("NH") || states.includes("ME");
  }

  // retrieve the days between the holiday and today's date from the server

  // private calculateDaysToGo(holidayDateStr: string, serverDateTime: DateTime): void {

  //     const serverDateToday = serverDateTime;                     // based on server date time

  //     const holidayDate = DateTime.fromISO(holidayDateStr);

  //     this.daysToGo = Math.floor(holidayDate.diff(serverDateToday, 'days').toObject().days);

  // }
}

export const SortSheduleByDates = (displayList: HolidayScheduleByStateRow[]) => {
  function compareDates(a, b) {
    const dateA = new Date(a.holidayDateFormatted);

    const dateB = new Date(b.holidayDateFormatted);

    return dateA.getTime() - dateB.getTime();
  }

  displayList.sort(compareDates);

  const today = new Date();
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() - 8);

  displayList.forEach((holiday) => {
    const holidayDate = new Date(holiday.holidayDateFormatted);

    holiday.upcoming = holidayDate > maxDate;
  });

  return displayList;
};
